import React, { useState, useEffect, useRef } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function AdminAddressAutocomplete({ value, onChange, placeholder = "Введите адрес доставки" }) {
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [inputValue, setInputValue] = useState(value || '');
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const justSelectedRef = useRef(false);
  const userTypingRef = useRef(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  useEffect(() => {
    if (!userTypingRef.current) return;
    if (justSelectedRef.current) {
      justSelectedRef.current = false;
      return;
    }
    const timeoutId = setTimeout(() => {
      if (inputValue && inputValue.length >= 3) {
        fetchSuggestions(inputValue);
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  const fetchSuggestions = async (query) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API_URL}/address/suggest?query=${encodeURIComponent(query.trim())}&count=7`
      );
      if (response.ok) {
        const data = await response.json();
        setSuggestions(data.suggestions || []);
        setShowSuggestions(true);
      } else {
        setSuggestions([]);
      }
    } catch {
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    userTypingRef.current = true;
    setInputValue(newValue);
    onChange(newValue, null);
  };

  const handleSuggestionClick = (suggestion) => {
    let address = suggestion.value;
    address = address.replace(/,\s*(?:кв\.?|квартира)\s*\d+.*$/i, '');

    if (suggestion.data && suggestion.data.house) {
      justSelectedRef.current = true;
      setInputValue(address);
      onChange(address, suggestion.data);
      setShowSuggestions(false);
      setSuggestions([]);
    } else {
      const addressWithComma = address + ', ';
      userTypingRef.current = true;
      setInputValue(addressWithComma);
      onChange(addressWithComma, null);
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          inputRef.current.setSelectionRange(addressWithComma.length, addressWithComma.length);
        }
      }, 50);
    }
  };

  return (
    <div ref={wrapperRef} style={{ position: 'relative' }}>
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        style={{
          width: '100%', padding: '8px 10px', fontSize: 13,
          border: '1px solid #ddd', '--ch': '5px', '--stroke': '#ddd', outline: 'none',
          boxSizing: 'border-box'
        }}
        onFocus={() => suggestions.length > 0 && setShowSuggestions(true)}
      />
      {isLoading && (
        <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 11, color: '#999' }}>
          Поиск...
        </div>
      )}
      {showSuggestions && suggestions.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 2,
          background: '#fff', border: '1px solid #ddd', '--ch': '5px', '--stroke': '#ddd',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)', maxHeight: 250, overflowY: 'auto', zIndex: 1000
        }}>
          {suggestions.map((s, i) => (
            <div key={i}
              onMouseDown={(e) => { e.preventDefault(); handleSuggestionClick(s); }}
              style={{
                padding: '8px 10px', cursor: 'pointer', fontSize: 13,
                borderBottom: i < suggestions.length - 1 ? '1px solid #EBEDEC' : 'none'
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#F4F4EF'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}
            >
              {s.value.replace(/^г Казань,?\s*/i, '')}
            </div>
          ))}
        </div>
      )}
      {showSuggestions && !isLoading && inputValue.length >= 3 && suggestions.length === 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 2,
          padding: '8px 10px', background: '#fff', border: '1px solid #ddd', '--ch': '5px', '--stroke': '#ddd',
          fontSize: 13, color: '#999', textAlign: 'center', zIndex: 1000
        }}>
          Адрес не найден
        </div>
      )}
    </div>
  );
}

export default AdminAddressAutocomplete;
